import { generateClient } from "aws-amplify/api";
import store from "store";

const TWIIK_CLIENT_ID = process.env.REACT_APP_TWIIK_CLIENT_ID;

const getPropByPath = (object, path, defaultValue) => {
  const _path = Array.isArray(path) ? path : path.split(".");
  if (object && _path.length) {
    return getPropByPath(object[_path.shift()], _path, defaultValue);
  }
  return object === undefined ? defaultValue : object;
};

const client = generateClient();

export default async function doRequest(
  requestMeta,
  successPath,
  useBasicAuth = false
) {
  let result;
  if (useBasicAuth) {
    const clientId = `${TWIIK_CLIENT_ID}`;
    result = await client.graphql(requestMeta, {
      Authorization: `APIKEY ${clientId}`,
    });
  } else {
    const token = store.getState().auth.accessToken;
    result = await client.graphql(requestMeta, {
      Authorization: `BEARER ${token}`,
    });
  }
  if (successPath) {
    const data = getPropByPath(result, successPath);
    if (data?.errorMessage) {
      throw data.errorMessage;
    }
    return data;
  } else if (result.errorMessage) {
    throw result.errorMessage;
  }
  return result;
}
